"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkArray = exports.parseStepDocumentFields = exports.calculateNewStepFields = exports.removeDuplicatesFromArray = exports.currentTimeStamp = exports.getStorageUrl = exports.getDomainFromEmail = void 0;
const firebaseconfig_1 = __importStar(require("@upflowy/firebaseconfig"));
const getDomainFromEmail = (email) => {
    // eslint-disable-next-line max-len
    const EMAIL_REGEXP = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    if (!EMAIL_REGEXP.test(email)) {
        return undefined;
    }
    let emailDomain = null;
    const positionOfDomain = email.search('@');
    if (positionOfDomain > 0) {
        emailDomain = email.slice(positionOfDomain + 1);
    }
    return emailDomain;
};
exports.getDomainFromEmail = getDomainFromEmail;
// eslint-disable-next-line max-len
const getStorageUrl = (location) => {
    if (firebaseconfig_1.default.env === 'dev' && firebaseconfig_1.appBaseURLs.consumer.startsWith('http://localhost')) {
        return `http://localhost:9199/v0/b/${firebaseconfig_1.default.storageBucket}/o/${encodeURIComponent(location)}?alt=media`;
    }
    return `${firebaseconfig_1.appBaseURLs.cdnPath}/${encodeURIComponent(location)}`;
};
exports.getStorageUrl = getStorageUrl;
exports.default = {
    getDomainFromEmail: exports.getDomainFromEmail,
};
const currentTimeStamp = () => new Date().getTime();
exports.currentTimeStamp = currentTimeStamp;
function removeDuplicatesFromArray(array) {
    return array.filter((columnName, index, self) => self.indexOf(columnName) === index);
}
exports.removeDuplicatesFromArray = removeDuplicatesFromArray;
const calculateNewStepFields = (fields) => {
    const stepFields = (fields !== null && fields !== void 0 ? fields : []).map((field) => ({
        ...field,
        namespacedName: field.namespacedName.split('.').splice(1).join('.'),
    }));
    return stepFields;
};
exports.calculateNewStepFields = calculateNewStepFields;
const parseStepDocumentFields = (steps) => {
    const flowVersionFields = [];
    steps.forEach((step) => {
        const { fields } = step;
        const stepFields = (0, exports.calculateNewStepFields)(fields);
        flowVersionFields.push(...stepFields);
    });
    return flowVersionFields;
};
exports.parseStepDocumentFields = parseStepDocumentFields;
const chunkArray = (array, chunkSize = 10) => {
    const chunckedArray = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunckedArray.push(array.slice(i, i + chunkSize));
    }
    return chunckedArray;
};
exports.chunkArray = chunkArray;
//# sourceMappingURL=helpers.js.map